export default __webpack_public_path__ + "static/media/p3-21.5752463f.png";